<template>
  <div
    id="settings"
  >
    <h2>
      Server & Service Settings
    </h2>

    <branding-nav />

    <h4
      class="alert alert-danger text-center"
      role="alert"
    >
      <strong>Warning</strong>: Editing these settings can interfere with
      your puzzle service!
    </h4>

    <button
      class="btn btn-sm btn-primary float-right"
      id="refresh-settings"
      v-on:click="refresh"
    >
      Refresh
    </button>

    <form
      method="put"
      accept-charset="UTF-8"
      autocomplete="off"
      :action="actionUrl"
      v-on:submit.prevent="update"
    >
      <spinner size="large" v-if="base.loading"></spinner>

      <div v-if="settings.length">
        <div
          class="form-group"
          v-for="setting in settings"
        >
          <div class="form-group">
            <label :for="setting.slug">
              {{ setting.name }}

              <span
                class="badge badge-danger "
                v-if="!setting.is_public"
              >
                Private
              </span>
            </label>

            <input
              class="form-control"
              :type="settingType(setting.slug)"
              :name="settingId(setting)"
              :id="setting.slug"
              :value="setting.val"
              :placeholder="setting.placeholder"
            />
          </div>
        </div>
      </div>

      <div class="form-group">
        <button
          type="submit"
          class="btn btn-primary form-control"
        >
          Save Settings
          <spinner size="small" v-if="base.loading"></spinner>
        </button>
      </div>
    </form>

    <form
      v-on:submit.prevent="importSettings"
    >
      <div
        class="form-group"
        v-if="!displayImportForm"
      >
        <button
          class="btn btn-primary form-control"
          v-on:click.prevent="showImport"
        >
          Import Settings
          <spinner size="small" v-if="base.loading" />
        </button>
      </div>

      <div
        class="form-group"
        id="show-import"
        v-if="displayImportForm"
      >
        <div
          class="row"
        >
          <div
            class="col"
          >
            <input
              type="file"
              name="brandings"
            />
          </div>
          <div
            class="col"
          >
            <button
              type="submit"
              class="btn btn-primary btn-block"
            >
              Import Settings
              <spinner size="small" v-if="base.loading" />
            </button>
          </div>
          <div
            class="col"
          >
            <button
              class="btn btn-danger btn-block"
              v-on:click="closeImport"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </form>

    <form
      v-on:submit.prevent="exportSettings"
    >
      <div class="form-group">
        <button
          class="btn btn-primary form-control"
        >

          Export Settings
          <spinner size="small" v-if="base.loading" />
        </button>
      </div>
    </form>

    <form
      method="delete"
      :action="actionUrl"
      v-on:submit.prevent="reset"
    >
      <div class="form-group">
        <button
          type="submit"
          class="btn btn-danger form-control"
        >
          Reset Settings to Default
          <spinner size="small" v-if="base.loading"></spinner>
        </button>
      </div>
    </form>

    <footer class="text-center">
      <config />
    </footer>
  </div>
</template>

<script>
import BrandingNav from '@/components/BrandingNav'
import Config from '@/components/Config'

import FlashStore from '@/stores/FlashStore'

import Spinner from 'vue-simple-spinner'

import { mapState } from 'vuex'

export default {
  data () {
    return {
      loading: false,
      displayImportForm: false
    }
  },

  computed: mapState({
    actionUrl () {
      return this.apiUrl('/settings', true)
    },

    base: state => state.base,
    settings: state => state.SettingModule.settings
  }),

  components: {
    'branding-nav': BrandingNav,
    'config': Config,
    'spinner': Spinner
  },

  created () {
    this.get()
  },

  methods: {
    settingId (setting) {
      return 'settings[' + setting.id + ']'
    },

    settingType (type) {
      const types = {
        'archive_starts_at': 'date',
        'embedded_puzzle_player_starts_at': 'date',
        'show_embedded_puzzle_player': 'checkbox'
      }

      return types[type] || 'text'
    },

    get () {
      this.$store.dispatch(
        `SettingModule/getSettings`
      ).catch(this.$root.processErrors)
    },

    importSettings (ev) {
      const form = ev.target

      this.$store.dispatch(
        `SettingModule/importSettings`, new FormData(form)
      ).catch(this.$root.processErrors).then(() => {
        this.closeImport()
      })
    },

    exportSettings () {
      this.$store.dispatch(
        `SettingModule/exportSettings`
      ).catch(this.$root.processErrors).then((response) => {
        let blob = new Blob([response.request.responseText], {
          type: response.headers['content-type']
        })

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'pa-settings.json'
        link.click()
      }, (resp) => {
        alert(resp)
      })
    },

    reset (ev) {
      if (confirm('Are you sure you want to reset to the default settings? This cannot be undone and may cause issues with your puzzle service!')) {
        this.loading = true

        this.bindSubmit(ev).then((response) => {
          this.loading = false
          FlashStore.result('Your changes have been saved.')
          this.get()
        }, (resp) => {
          this.loading = false
          this.processErrors(resp)
        })
      }
    },

    refresh () {
      this.$store.dispatch(
        `SettingModule/refreshSettings`
      ).catch(this.$root.processErrors)
    },

    closeImport () {
      this.displayImportForm = false
    },

    showImport () {
      this.displayImportForm = true
    },

    update (ev) {
      this.loading = true

      this.bindSubmit(ev).then((response) => {
        this.loading = false
        FlashStore.result('Your changes have been saved.')
        this.get()
      }, (resp) => {
        this.loading = false
        this.processErrors(resp)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Settings.vue